module.exports = __webpack_public_path__ + "img/box_pro_two_2.e0391a3d.jpg";